/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Footer = () => (
  <footer className="main-footer ">
    <section className="footer">
      <div className="container">
        <div className="lets-talk">
          Let's talk
          <div>
            <span className="icon-arrow_forward"></span>{" "}
            <a href="mailto:sales@cloudalgo.com">sales@cloudalgo.com</a>
          </div>
        </div>

        <div className="row">
          <div className="col-md-7 align-self-center">
            <address>
              CloudAlgo, established in the year 2019, is a consulting firm that
              prioritizes its customers and a Salesforce Consulting Partner.
            </address>
            <div className="d-flex flex-row">
              <div className="p-2">
                <a
                  href="https://appexchange.salesforce.com/appxConsultingListingDetail?listingId=a0N4V00000JdabDUAR&legacy=true"
                  target="_blank"
                  rel="noreferrer"
                >
                  <StaticImage
                    src="./../images/salesforce/Salesforce_Partner_Badge_RGB.png"
                    alt="Certificated Salesforce Partner"
                    placeholder="blurred"
                    layout="fixed"
                    height={100}
                  />
                </a>
              </div>
              <div className="p-2">
                <a
                  href="https://appexchange.salesforce.com/appxConsultingListingDetail?listingId=a0N4V00000JdabDUAR&legacy=true"
                  target="_blank"
                  rel="noreferrer"
                >
                  <StaticImage
                    src="./../images/salesforce/Available_On_Appexchange_Badge_RGB.png"
                    alt="Available on Salesforce Appexchange"
                    placeholder="blurred"
                    layout="fixed"
                    height={100}
                  />
                </a>
              </div>
            </div>

            <div className="copy-right">
              {new Date().getFullYear()} © cloudalgo.com, All rights reserved.
            </div>
          </div>

          <div className="col-md-5 page-links">
            <ul className=" list-unstyled">
              <li>
                <Link to="/aboutUs">About</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/blog">Blogs</Link>
              </li>
              <li>
                <a href="/page/disclaimer">Disclaimer</a>
              </li>
            </ul>

            <ul className=" list-unstyled">
              <li>
                <a
                  href="https://www.linkedin.com/company/cloudalgo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Linkedin
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/cloudalgo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Github
                </a>
              </li>
              <li>
                <a href="" target="_blank" rel="noopener noreferrer">
                  Twitter
                </a>
              </li>
              <li>
                <a href="/page/privacy-policy">Privacy Policy</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </footer>
);

export default Footer;
